export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.3.23-1448.38',
  commitId: '72cd20831ea1527874a631842834db6de560378f',
  commitTime: '2026-03-23T14:48:38.000Z',
});
